let isLocalStorageAvil: boolean | undefined = undefined;

// used for unit tests only
export const resetIsLocalStorageAvil = () => (isLocalStorageAvil = undefined);

export default function IsLocalStorageAvil() {
    if (typeof isLocalStorageAvil !== 'undefined') {
        return isLocalStorageAvil;
    }

    try {
        localStorage.setItem('test', 'test');
        if (localStorage.getItem('test') !== 'test') {
            isLocalStorageAvil = false;
            return false;
        }
        localStorage.removeItem('test');
        isLocalStorageAvil = true;
        return true;
    } catch (e) {
        isLocalStorageAvil = false;
        return false;
    }
}
